import { connect } from 'react-redux';
import { updateEBookDataRoutine } from 'redux-state/ducks/player';
import NavigationMenu from './navigation-menu.component';

const mapDispatchToProps = {
  updateEBookDataAction: updateEBookDataRoutine.request,
};

export default connect(null, mapDispatchToProps)(NavigationMenu);
